module.exports = __webpack_public_path__ + "media/Buchteaser_Jugendroman.86e75a39.mp3";